define("powergen/components/x-improvement",
  [],
  function() {
    "use strict";
    var XImprovementComponent;

    XImprovementComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['improvement'],
      classNameBindings: ['improvement.id', 'improvement.part.type.id', 'improvement.isCorrect:is-correct:is-incorrect', 'improvement.partIsSelected', 'improvement.selectedPart.id', 'improvement.isCorrected'],
      attributeBindings: ['style'],
      style: (function() {
        return this.get('util').styleString({
          'width': '%@px'.fmt(this.get('improvement.size.width')),
          'height': '%@px'.fmt(this.get('improvement.size.height')),
          'left': '%@px'.fmt(this.get('improvement.position.x')),
          'top': '%@px'.fmt(this.get('improvement.position.y'))
        });
      }).property('improvement.position.x', 'improvement.position.y'),
      click: function(e) {
        e.stopPropagation();
        return this.sendAction('selectImprovement', this.get('improvement'));
      }
    });


    return XImprovementComponent;
  });